const PYVAR_ALLOWED_QUERY_PARAMS = [
    'r',
    'token',
    'email',
    'membership_code',
    'wz_link',
    'barcode',
    'o',
    'locale',
    'color_primary',
    'resale_uuid',
    'magic_link',
    'waiting_list_ticket',
];

const MAPPING_QUERY_PARAMS = {
    'magic_link': 'token',
}

export default function get_url_query() {
    // If we have environment in url query append it
    const queryparams = new URLSearchParams(window.location.search);
    const widget_query = new URLSearchParams();

    const env = queryparams.get('env');
    if(env && ['local', 'dave'].includes(env)) {
        widget_query.append('env', env);
    }

    for(const pyvar_query of PYVAR_ALLOWED_QUERY_PARAMS) {
        if(queryparams.has(pyvar_query)) {
            const key = MAPPING_QUERY_PARAMS[pyvar_query] || pyvar_query;
            widget_query.append(key, queryparams.get(pyvar_query));
        }
    }

    return `?${widget_query.toString()}`;
};
